// extracted by mini-css-extract-plugin
export default {"resetButton":"myYxOZg","root":"OzA6ZVq","draggable":"dNVEvMO","draggableHorizontal":"pTLJMum","draggableVertical":"oW3XCoI"};